export class SearchModel {
    searchBy: string;
    searchKey: string;

    searchKeyInput: string;

    fboId: string;
    userName: string;
    firstName: string;
    lastName: string;
    fourDigitSSN: string;
    email: string;
    phoneNumber: string;
    city: string;
    state: string;
    homeCountry: string;
    sponsor: string;
    status: string;
    orderNumber: string;

    orderId: string;
    sixDigitsOfCC: string;
    country: string;
    referringFBOId: string;
    lastFourDigitsOfCC: string;
    fromDate: Date;
    toDate: Date;
    isAdvancedSearch:boolean;
    memberType:string;
    memberLevel:string;
}
 


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/search-model.ts